(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/button-bet.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/button-bet.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  useRef,
  useEffect
} = React;
const {
  ReactButtonBet: UiButtonBet
} = svs.ui;
const {
  wagerSystemTypes
} = svs.components.tipsen.engine.constants;
const betTypeToShowDistribution = [wagerSystemTypes.OWNROWS, wagerSystemTypes.REDUCERA_FRITT, wagerSystemTypes.ENKELRADER];
const ButtonBet = _ref => {
  let {
    result,
    branding,
    isCorrect,
    uSign,
    isSelected,
    distribution,
    betProperties = []
  } = _ref;
  const buttonRef = useRef();
  const classNames = ['pg_coupon_static__bet_btn'];
  let isDistribution = false;
  isCorrect && classNames.push('btn-bet-result');
  const additionalProps = {};
  const showDistibutionInBetButtons = betProperties.length > 0 && distribution ? betProperties.some(betProp => betTypeToShowDistribution.includes(betProp)) : false;
  if (showDistibutionInBetButtons) {
    additionalProps.title = "Systemf\xF6rdelning ".concat(distribution, "%");
    additionalProps['data-outcome'] = result.resultText.text;
    classNames.push('pg_coupon_static__bet_btn--is-distribution');
    distribution < 50 && classNames.push('pg_coupon_static__bet_btn--is-low-distribution');
    isDistribution = true;
  }
  useEffect(() => {
    if (isDistribution) {
      buttonRef.current.style.setProperty('--distribution', "".concat(distribution, "%"));
    }
  }, [isDistribution, distribution]);
  return React.createElement(UiButtonBet, _extends({
    ariaLabel: result.ariaLabel,
    branding: branding,
    className: classNames.join(' '),
    key: result.resultText.text,
    label: result.resultText.text,
    ref: buttonRef,
    selected: isSelected,
    size: "100"
  }, uSign ? {
    system: 'U'
  } : {}, additionalProps));
};
setGlobal('svs.components.tipsen.couponStatic.ButtonBet', ButtonBet);

 })(window);